import validator from 'validator';
import { parsePhoneNumberFromString } from 'libphonenumber-js/max';
import { DEFAULT_PHONE_PREFIX } from './localeUtils';

export const normalizeOptionalPhone = (value, country = DEFAULT_PHONE_PREFIX) => {
  const rawValue = value.trim();

  if (validator.isEmpty(rawValue, { ignore_whitespace: true })) {
    return { isValid: true, value: '' };
  }

  const phone = rawValue.startsWith('+')
    ? parsePhoneNumberFromString(rawValue)
    : parsePhoneNumberFromString(rawValue, country);
  const phoneType = phone?.getType();

  if (!phone?.isValid() || !['MOBILE', 'FIXED_LINE_OR_MOBILE'].includes(phoneType)) {
    return { isValid: false, value: '' };
  }

  return { isValid: true, value: phone.number };
};
